// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__x0Jg1","navigation":"Navbar_navigation__tLBbC","logo":"Navbar_logo__MdEUL","other":"Navbar_other__32u0L"};